<template>
    <div style="padding: 20px;">
        <div id="login-container" class="col-xs-12 col-md-5 col-sm-12">
            <img src="/img/loading.gif" alt="">
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {validateEmailAddress} from '../../logic/account'
    import ModalResendEmail from '../../components/ModalResendEmail'

    export default {
        data(){
            return {

            }
        },
        components: {},
        methods: {
            showSuccessMsg: function(message, msg_type){
                this.$toast.open({message: message, type: msg_type})
            },           
        },
        mounted: function(){
            let token = this.$route.query.token;
            if(token){
                validateEmailAddress(token).then(response => {
                    console.log(response)
                    if(response.data.success == true){
                        localStorage.clear();
                        localStorage.setItem('jwt',response.data.token)
                        if (localStorage.getItem('jwt') != null){
                            this.$emit('loggedIn')
                            this.$router.push({name: "workspaces"})
                        }
                    }else{
                        this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                    }
                }).catch(error => {

                })
            }
        }
    }
</script>


<style scoped>
    #login-container >>> label,
    #register-container >>> label{
        text-align: left;
        padding: 0px;
        font-weight: 400;
    }

    #login-container >>> .field,
    #register-container >>> .field{
        margin-bottom: 20px;
    }

    #login-container{
        display: block;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
        text-align: left;
    }

    #login-container h2{margin:20px;}
    #login-container .center{
        text-align:center;
        margin:20px;
    }

    #register-container{
        display: none;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
    }

    #register-container h2{margin:20px;}
    #register-container .center{
        text-align:center;
        margin:20px;
    }

    #header{display: none;}
</style>
